import React from 'react';

/** 必填星号：红色醒目，避免继承 label 灰色 */
export default function RequiredMark() {
  return <span className="tko-field__required" aria-hidden="true">*</span>;
}

/**
 * 文案末尾的「 *」换成红色 RequiredMark；非字符串原样返回。
 * @param {React.ReactNode} label
 * @returns {React.ReactNode}
 */
export function withRequiredMark(label) {
  if (label == null || label === false) return null;
  if (typeof label !== 'string') return label;
  const match = String(label).match(/^(.*?)\s*\*\s*$/);
  if (!match) return label;
  return (
    <>
      {match[1]}
      <RequiredMark />
    </>
  );
}
